// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiDiagnosis {
    static getAttributeTypeMap() {
        return PharmacyBiDiagnosis.attributeTypeMap;
    }
}
PharmacyBiDiagnosis.discriminator = undefined;
PharmacyBiDiagnosis.additionalProperties = false;
PharmacyBiDiagnosis.attributeTypeMap = [
    {
        "name": "jCode",
        "baseName": "jCode",
        "type": "string"
    },
    {
        "name": "jCodeDescription",
        "baseName": "jCodeDescription",
        "type": "string"
    },
    {
        "name": "primaryIcdCode",
        "baseName": "primaryIcdCode",
        "type": "string"
    },
    {
        "name": "primaryIcdDescription",
        "baseName": "primaryIcdDescription",
        "type": "string"
    },
    {
        "name": "secondaryIcdCode",
        "baseName": "secondaryIcdCode",
        "type": "string"
    },
    {
        "name": "secondaryIcdDescription",
        "baseName": "secondaryIcdDescription",
        "type": "string"
    },
    {
        "name": "treatmentDate",
        "baseName": "treatmentDate",
        "type": "Date"
    },
];
//# sourceMappingURL=pharmacyBiDiagnosis.js.map